import { getMedicineRefrigerator, getTelemetry } from '@/api/'

const state = () => ({})

const mutations = {}

const actions = {
  GET_MEDICINE_REFRIGERATOR({ commit }, data) {
    return new Promise((resolve, reject) => {
      getMedicineRefrigerator({
        buildingId: data.BuildingId,
        type: data.type,
        deviceId: data.deviceId,
        assetId: data.assetId,
        start: data.start,
        end: data.end,
        group: data.group
      }, message => {
        resolve(message.data)
      }, error => {
        reject(error)
      })
    })
  },
  GET_TELEMETRY({ commit, rootState }, data) {
    return new Promise((resolve, reject) => {
      getTelemetry({
        buildingId: rootState.User.building.BuildingId,
        assetId: data.assetId,
        start: data.start,
        end: data.end
      }, message => {
        resolve(message.data)
      }, error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
